'use client'

import React from 'react'
import ContactForm from './ContactForm'
import ContactDetails from './ContactDetails'
import { motion } from 'framer-motion'
import { useLanguage } from '@/app/(frontend)/providers/LanguageProvider'

const HeadOfficeInformation = () => {
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  return (
    <section className="w-full min-h-screen bg-white text-black py-[50px] relative">
      <section className="section-container xl:h-[984px] lg:pt-[50px] m-auto">
        <div className="relative flex flex-col sm:gap-[45px] lg:flex-row justify-between">
          {/* Left Side - Contact Details (desktop) */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true, amount: 0.2 }}
            className="hidden lg:block"
          >
            <ContactDetails />
          </motion.div>

          {/* Right Side - Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <ContactForm />
          </motion.div>

          {/* Mobile Contact Details (shown below form) */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true, amount: 0.2 }}
            className="lg:hidden"
          >
            <ContactDetails />
          </motion.div>
        </div>
      </section>

      {/* Background Image */}
      {isArabic ? (
        <>
          <img
            src="/images/Global_transportation_system_1_Left.png"
            alt="globel-transport"
            className="absolute -top-3 md:-top-12 lg:-top-45 left-0 w-[130px] md:w-[180px] lg:w-[236px] lg:h-[253px] xl:w-[258px] xl:h-[273px]"
          />
        </>
      ) : (
        <>
          <img
            src="/images/Global_transportation_system_1_Right.png"
            alt="globel-transport"
            className="absolute -top-3 md:-top-12 lg:-top-45 right-0 w-[130px] md:w-[180px] lg:w-[236px] lg:h-[253px] xl:w-[258px] xl:h-[273px]"
          />
        </>
      )}
    </section>
  )
}

export default HeadOfficeInformation
